export default __webpack_public_path__ + "static/media/brand10.40b892c6.jpg";